import React from 'react';
import classnames from 'classnames';
import { useDropdown } from '../../context/DropdownContext';
import Button from '@components/legacy/core/Button';

const Dropdown = ({ id, children, btnConfig, btnClass, disabled, className, icon, label, withScroll, iconPosition }) => {
    const { openDropdownId, setOpenDropdownId } = useDropdown();

    const isOpen = openDropdownId === id;

    const toggleDropdown = () => {
        if (isOpen) {
            setOpenDropdownId(null);
        } else {
            setOpenDropdownId(id);
        }
    };

    const ToggleDropdownButton = ({ children }) => {
        return btnConfig ? (
            <Button
                {...btnConfig}
                className={classnames(btnClass, {
                    disabled: disabled,
                })}
                onClick={() => !disabled && toggleDropdown(id)}
            >
                {children}
            </Button>
        ) : (
            <button
                type="button"
                className={classnames(btnClass, {
                    disabled: disabled,
                })}
                onClick={(e) => {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    if (!disabled) {
                        toggleDropdown();
                    }
                }}
            >
                {children}
            </button>
        );
    };

    return (
        <div id={`${id}-container`} className={classnames('dropdown-container', className)}>
            <div className="btn-container">
                <ToggleDropdownButton>
                    {icon && iconPosition === 'left' && <span className={icon}></span>}
                    {label}
                    {icon && iconPosition === 'right' && <span className={icon}></span>}
                </ToggleDropdownButton>
            </div>

            {isOpen && (
                <div
                    className={classnames('dropdown dropdown-with-header dropdown-react', {
                        'with-scroll': withScroll,
                    })}
                >
                    <ul
                        style={{ display: 'block' }}
                        className="dropdown-menu dropdown-menu-right"
                        id={`${id}`}
                        aria-labelledby={`${id}`}
                    >
                        {children && children({ toggleDropdown })}
                    </ul>
                </div>
            )}
        </div>
    );
};

Dropdown.defaultProps = {
    btnConfig: null,
    btnClass: null,
    disabled: false,
    icon: null,
    className: '',
    withScroll: false,
    label: null,
    iconPosition: 'left',
};

export default Dropdown;
